import React, { useState, useEffect, forwardRef, useMemo, useCallback } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import { Formik } from "formik";
import { Select } from "@appkit4/react-components/select";
import * as Yup from "yup";
import { handleNotificationSubmit } from "../notification/notification";
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import { TextArea } from "@appkit4/react-components/field";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";
import PropTypes from "prop-types";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import { Button } from "@appkit4/react-components/button";
import { Loading } from '@appkit4/react-components/loading';

export default function AssessorComments(props) {
  const {
    RequestDetails,
    tableDataProp,
    wpCategoryData,
    getSelfAssessmentsforAssessor,
    analyst,
    vendorDetails
  } = props;
  
  const commentData = RequestDetails && RequestDetails[RequestDetails.length - 1]?.comments
  const [manager, setManager] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [comments, setComments] = useState(commentData);
  const [assessorStatus, setAssessorStatus] = useState("");
  const [tableData, setTableData] = useState(tableDataProp);
  const [initialValues, setInitialValues] = useState({});
  const [selectedType, setSelectedType] = useState(1);
  const [workProgramName, setWorkProgramName] = useState([]);
  const [save, setSave] = useState(false);
  const [modalVisible, setmodalVisible] = useState(false);
  const [commentsFormat, setCommentsFormat] = useState(false);
  const { sendRequest: downloadAPI } = useHttp();
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: approveSelfAssessment } = useHttp();
  const { sendRequest: getAllManagersList } = useHttp();
  const [gridApi, setGridApi] = useState(null);
  const [loader, setLoader] = useState(true);


  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
    // Enable filtering on all columns,
    // flex:1,
    sortable: true,
    cellDataType: false,
    wrapText: true,
    autoHeight: true,
  }));

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  useEffect(() => {
    setTableData(tableDataProp)
    let data = {};
    if (tableDataProp.length > 0) {
      data = tableDataProp[0];
    }
    let tableType = [];
    tableType = Object.keys(data);
    if (tableDataProp && tableType.includes("Area")) {
      setSelectedType(2);
    } else {
      setSelectedType(1);
    }
    getInitialDataHandler();
    getWorkPrograms();
  }, [tableDataProp]);

  useEffect(() => {
    setInitialValues((oldValue) => {
      return {
        ...oldValue,
        assessmentID: props.RequestDetails[0].assessment_id,
        vendorName: props.RequestDetails[0].vendor_id,
        scopeOfAssessment: props.RequestDetails[0].scopeofassessment,
        manager: props.RequestDetails[0].manager,
        respondent: props.RequestDetails[0].vendorrespondant,
        workProgram: props.wpCategoryData[0].workprogramid,
        vendorComment:props.RequestDetails[0].vendorcomments,
      }
    })
  }, [props.RequestDetails, props.wpCategoryData])

  const getWorkPrograms = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) => setWorkProgramName(data.MSG)
    );
  };

  let getInitialDataHandler = async () => {
    await getAllVendorList(
      APIService.getAllVendorList(),
      (result) => {
        if (result.CODE) {
          setVendors(result.MSG);

        }
      },
      (err) => {
        displayToastMessage("Something went wrongs, Please try again!", "error");
      }
      
    );

    await getAllManagersList(APIService.getAllManagersList(), (result) => {
      if (result.CODE) {
        setManager(result.MSG);

      }
    }, errorHandler)
    setLoader(false);

  };

  const handleCancel = () => {
    setmodalVisible(false);
  };

  let visibleToggle = (rowData, type) => {
    let keys = Object.keys(rowData);

    if (type === "Domain") {
      return !!(keys.includes("Domain") && keys.includes("Sub Domain"));
    } else if (type === "subDomain") {
      return !!(keys.includes("Sub Domain"));
    } else if (type === "area") {
      return !!(keys.includes("Area") && keys.includes("Sub Area"));
    } else if (type === "subArea") {
      return !!(keys.includes("Sub Area"));
    }
  };

  let handleCheckFieldValue = (rowData, type, value) => {
    let rowId = rowData?.rowIndex;
    let UpdatedTableDta = [...tableData];

    if (type === "domain") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Domain") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].domainToggle = value;
          UpdatedTableDta[i].subDomainToggle = value;
          UpdatedTableDta[i].controlIDToggle = value;
        }
      }
    } else if (type === "subDomain") {
      let i;
      //CHECKING FOR PARENT ON STATE(IF PARENT FALSE CHILD CAN NOT BE TRUE)
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].domainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              for (i = rowId; i < tableData.length; i++) {
                let keys = Object.keys(tableData[i]);
                if (keys.includes("Sub Domain") && !(i === rowId)) {
                  break;
                } else {
                  UpdatedTableDta[i].subDomainToggle = value;
                  UpdatedTableDta[i].controlIDToggle = value;
                  //     if(keys.includes("Sub Domain") ){//
                  //         UpdatedTableDta[i].subDomainToggle = value;
                  //         UpdatedTableDta[i].controlIDToggle = true;
                  //     }
                  //    else{UpdatedTableDta[i].controlIDToggle = false;}
                }
              }
            }
            break;
          }
        }
      } else {
        for (i = rowId; i < tableData.length; i++) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain") && !(i === rowId)) {
            break;
          } else {
            UpdatedTableDta[i].subDomainToggle = value;
            UpdatedTableDta[i].controlIDToggle = value;
          }
        }
      }
    } else if (type === "controlID") {
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Domain")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex + 1; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (keys.includes("Sub Domain")) {
            endIndex = k - 1;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].controlIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Domain")) {
              UpdatedTableDta[l].subDomainToggle = true;
            } else {
              UpdatedTableDta[l].subDomainToggle = true;
            }
          }
        } else {
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subDomainToggle = false;
          }
        }

        UpdatedTableDta[rowId].controlIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    } else if (type === "area") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].areaToggle = value;
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "subArea") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Sub Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "questionID") {
      // UpdatedTableDta[rowId].questionIDToggle = value;
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Area")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (k != startIndex && keys.includes("Sub Area")) {
            endIndex = k;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].questionIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Area")) {
              UpdatedTableDta[l].subAreaToggle = true;
            } else {
              UpdatedTableDta[l].subAreaToggle = true;
            }
          }
        } else {
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subAreaToggle = false;
          }
        }

        UpdatedTableDta[rowId].questionIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    }
    setTableData(UpdatedTableDta);
  };

  const InitialValues = {
    assessmentID: RequestDetails && RequestDetails[0].assessment_id,
    vendorName: RequestDetails && RequestDetails[0].vendor_id,
    scopeOfAssessment: RequestDetails && RequestDetails[0].scopeofassessment,
    manager: RequestDetails && RequestDetails[0].manager,
    respondent: RequestDetails && RequestDetails[0].vendorrespondant,
    workProgram: wpCategoryData && wpCategoryData[0].workprogramid,
    vendorComment: RequestDetails && RequestDetails[0]?.vendorcomments
  };

  const validationSchema = Yup.object().shape({
    vendorName: Yup.string()
      .required("Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    scopeOfAssessment: Yup.string()
      .required("Scope of assessment is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    workProgram: Yup.number().required("Work program is required"),
    assessmentID: Yup.number().required("Assessment ID is required"),
    manager: Yup.string()
      .required(" Third party manager is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    respondent: Yup.string()
      .required("Third party respondent is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
  });

  const [colDefs1] = useState(
    [
        { headerName: "Question Id", field: "Question Id", editable: 'never', width:"120" },
             { headerName: "Question", field: "Question",tooltipField:"Question", width: 400 },
{headerName: "Third Party Response",
  field: "Third Party Response",
  editable: false,
  cellEditor: 'agSelectCellEditor',
  cellEditorPopup: false,
  cellEditorParams: {
      values: ['YES', 'NO','NA'],
  } },
    
      {
        children: [
          { columnGroupShow: "open", headerName: "Area",
            field: "Area",width:"120" },
          { columnGroupShow: "open", headerName: "Sub Area", field: "Sub Area", width:"100"},
          { columnGroupShow: "open" ,headerName: "Instructions (If any)", field: "Instructions (If any)" },
          {
            columnGroupShow: "closed",headerName: "Assessor Comments*",tooltipField:"Assessor Comments ", field: "Assessor Comments ", cellStyle: {border: '0.5px solid #dedede'}, editable: true, cellEditor: "agLargeTextCellEditor", cellEditorPopup: true, cellEditorParams: {
              maxLength: 500
            }, valueSetter: (params) => {
              const data = params.newValue;
    
              if (data?.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1) {
                displayToastMessage("Allowed special characters .:/,()", "error");
    
                return false;
              } else {
                params.data["Assessor Comments "] = data;
                return true;
              }
            }
          },
          {
            columnGroupShow: "closed", headerName: "Evidence",
            field: "Evidence",
            editable: false,
            cellRenderer: (rowData) => {
              if (rowData?.data?.Evidence_File_Content) {
                return rowData?.data?.Evidence ?
                  (rowData?.data?.Evidence_File_Content ?
                    (
                      <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidence} className="hyperText">{rowData?.data?.Evidence}</a>
                    )
                    : (<>{rowData?.data?.Evidence}</>))
                  : (<p></p>)
              } else {
                return rowData?.data?.Evidence ?
                  (rowData?.data?.Evidence_File_Path ?
                    (
                      <div onClick={() => getDownloadFile(rowData?.data?.Evidence_File_Path, rowData?.data?.Evidence)} className="hyperText">{rowData?.data?.Evidence} </div>
                    )
                    : (<>{rowData?.data?.Evidence}</>))
                  : (<p></p>)
              }
            },
          }, 
          {
            columnGroupShow: "closed", headerName: "Closure Status*",
            field: "Closure Status",
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorPopup: false,
            cellEditorParams: {
              values: ['Yes', 'No','NA'],
            }, cellStyle: {border: '0.5px solid #dedede'},
    
          },{
            columnGroupShow: "closed", headerName: "Risk Rating*",
          field: "Risk Rating",
          editable: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorPopup: false,
          cellEditorParams: {
              values: ['High', 'Medium','Low'],
          }, cellStyle: {border: '0.5px solid #dedede'},
      },  
        ],
      },
     
  
    ])
  const [colDefs2] = useState(
    [
         { headerName: "Question Id", field: "Question Id", editable: 'never', width:"103" },
         { headerName: "Question", field: "Question",tooltipField:"Question", flex: 1, minWidth: 300, maxWidth: 950 },
{headerName: "Third Party Response",
  field: "Third Party Response",
  editable: false,
  cellEditor: 'agSelectCellEditor',
  cellEditorPopup: false,
  cellEditorParams: {
      values: ['YES', 'NO','NA'],
  },width:"165", cellStyle: {textAlign: 'center'},},
  {headerName: "Third Party Comments",
    field: "Third Party Comments",
    field: "Vendor Response",
    editable: 'never',flex: 1, minWidth: 175, maxWidth: 500},
  {
    columnGroupShow: "closed", headerName: "Evidence",
    field: "Evidences",
    width:"165",
    editable: false,
    cellRenderer: (rowData) => {

      if (rowData?.data?.Evidence_File_Content) {
        return rowData?.data?.Evidences ?
          (rowData?.data?.Evidence_File_Content ?
            (
              <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidences} className="hyperText">{rowData?.data?.Evidences}</a>
            )
            : (<>{rowData?.data?.Evidences}</>))
          : (<p></p>)
      } else {
        return rowData?.data?.Evidences ?
          (rowData?.data?.Evidence_File_Path ?
            (
              <div onClick={() => getDownloadFile(rowData?.data?.Evidence_File_Path, rowData?.data?.Evidences)} className="hyperText">{rowData?.data?.Evidences} </div>
            )
            : (<>{rowData?.data?.Evidences}</>))
          : (<p></p>)
      }
    },
 },
      {
        headerName: "Assessor Details",
        children: [
          { columnGroupShow: "open", headerName: "Area",
            field: "Area", flex: 1, minWidth: 120, maxWidth: 355 },
            { columnGroupShow: "open", headerName: "Sub Area", field: "Sub Area", flex: 1, minWidth: 100, maxWidth: 360},
          { columnGroupShow: "open" ,headerName: "Instructions (If any)", field: "Instructions (If any)" },
          
          
          {
            columnGroupShow: "closed", headerName: "Closure Status*",
            field: "Closure Status",
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorPopup: false,
            cellEditorParams: {
              values: ['Yes', 'No','NA'],
            }, cellStyle: {border: '0.5px solid #dedede',textAlign: 'center'},width:"128"
          },{
            columnGroupShow: "closed",width:"167",headerName: "Assessor Comments*",tooltipField:"Assessor Comments ", field: "Assessor Comments ", cellStyle: {border: '0.5px solid #dedede'}, editable: true, cellEditor: "agLargeTextCellEditor", cellEditorPopup: true, cellEditorParams: {
              maxLength: 500
            },flex:1, minWidth: 200, maxWidth: 500, valueSetter: (params) => {
              const data = params.newValue;
    
              if (data?.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1) {
                displayToastMessage("Allowed special characters .:/,()", "error");
    
                return false;
              } else {
                params.data["Assessor Comments "] = data;
                return true;
              }
            }
          },{
            columnGroupShow: "closed",width:"145", headerName: "Risk Rating*",
          field: "Risk Rating",
          editable: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorPopup: false,
          cellEditorParams: {
              values: ['High', 'Medium','Low'],
          }, cellStyle: {border: '0.5px solid #dedede',textAlign: 'center'},
      },  
        ],
      },
     
  
    ]);

  const onBtnExport = () => {
    gridApi?.exportDataAsCsv();
  };

  // const defaultColGroupDef = useMemo(() => {
  //   return {
  //     headerName: "Assessor Details",
  //   };
  // }, []);


  const onFilterTextBoxChanged = (e) => {
    gridApi.setQuickFilter(e.target.value);
  }

  const onCellValueChanged = ((event) => {
    var data = event.data;
    const dataUpdate = [...tableData];
    const index = event.rowIndex;
    dataUpdate[index] = data;
    setTableData([...dataUpdate]);
  });

  const Rating=(response)=>{
    let Rating;
    if(response<=85 && response>=0)
      {
        Rating='High';
      }
      else if(response>=86 && response<=94)
        {
          Rating='Medium';
        }
        else if(response>=95){
          {
            Rating='Low';
          }
        }
        return Rating;
  }

  const handleUpdate = async () => {
    let z;
    let flag=0;
      for (z = 0; z < tableData.length; z++) {
       let keys = Object.keys(tableData[z]);
        if (!keys.includes("Closure Status")) {
          flag=1;
          break;

      }
      }
    if(assessorStatus=='Approved' && flag=='1')
    {
      let MSG = "Please Select Closure Status";
          displayToastMessage(MSG, "warning");
    }
  else{
    let saveCondition;
    let saveStatus;
    if (assessorStatus == "Save") {
      saveCondition = 3;
      saveStatus = "Updated";
    } else {
      saveCondition = 4;
      saveStatus = assessorStatus;
    }

    //score calculation
    var closure = tableData.map(function(acc, obj){
      return acc['Closure Status'];
  }).filter((data)=>{
return(data!=undefined);
  })
  var count = 0,nocount=0,nacount=0;
for(var i = 0; i < closure.length; ++i){
    if(closure[i] == 'Yes')
        count++;
    if(closure[i] == 'No')
      nocount++;
    if(closure[i] == 'NA')
      nacount++;
}

const TotalQuestions =closure.length;
const NumberofYesResponses =count;
const NumberofNoResponses =nocount;
const NumberofNAResponses =nacount;
const adjustedTotalNumberOfQuestions =TotalQuestions-NumberofNAResponses;
const yesResponse=Math.ceil((NumberofYesResponses/adjustedTotalNumberOfQuestions)*100);
    let data = {
      email:sessionStorage.getItem("email"),
      paramvendorid: RequestDetails[0]?.vendor_id,
      businessUser:vendorDetails.businessuseremail,
      paramvendorassessmentrequestid:
        RequestDetails[0]?.vendor_assessment_requestid,
      paramvendorassessmentplanid:
        RequestDetails[0]?.vendorplanid,
      paramcomments: comments,
      paramroleid: Number(sessionStorage.getItem("roleId")),
      paramuserid: Number(sessionStorage.getItem("userId")),
      paramstatus: saveStatus,
      paramVendorAssessmentID:
        RequestDetails && RequestDetails[0].assessment_id,
      paramCategoryData: JSON.stringify(tableData),
      paramvendorresponsestatusid: saveStatus == "Rejected" ? 5 : saveCondition,
      paramvendorreviewstatusid: saveStatus == "Rejected" ? 5 : saveCondition,
      paramscore:yesResponse?yesResponse:0,
      paramrating:yesResponse?Rating(yesResponse):'High',
      paramyescount:NumberofYesResponses,
      paramnocount:NumberofNoResponses,
      paramnacount:NumberofNAResponses,
      paramanalyst:analyst,
      nocount:nocount,
      paramUser:sessionStorage.getItem("username"),
      vendorName:RequestDetails[0].vendor_name,
      vendorEmail:vendorDetails.vendorpointof_contact_email,
      workProgrammeId:wpCategoryData[0].workprogramid,
    };
    approveSelfAssessment(APIService.approveSelfAssessment(data), (result) => {
      if (result.CODE) {
        displayToastMessage(result.MSG, "success");
        let notifData = {
          paramuserid: Number(sessionStorage.getItem("userId")),
          paramreqid: RequestDetails && RequestDetails[0].assessorid,
          paramcontent: "Approved self Assessment",
          paramnextroleid: 4,
          paramcreatedby: Number(sessionStorage.getItem("roleId")),
          parammsgtype: result.MSG,
        };
        handleNotificationSubmitAPI(
          APIService.handleNotificationSubmit(notifData),
          () => { }
        );
        setmodalVisible(false);
        props.sendBack();


      }
    }, errorHandler)
  }
  };

  const errorHandler = () => {
    let MSG = "Something went wrong, Please try again!";
    displayToastMessage(MSG, "error");
  }

  const handleStatus = (param) => {
    if (!commentsFormat) {
      setmodalVisible(true);
      setAssessorStatus(param);
    } else {
      setCommentsFormat(true);
    }
  };

  const handleChangeComment = (e) => {
    if (e.search(/[^()0-9a-zA-Z,. ]/) === -1) {
      setCommentsFormat(false);
    } else {
      setComments();
      setCommentsFormat(true);
    }
    setComments(e);
  };

  const downloadResponseHandler = (result, fileName) => {
    if (result) {
      const blob = new Blob([result?.data], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      displayToastMessage("File Downloaded successfully", "success");
    }
  };

  const getDownloadFile = async (data, fileName) => {
    await downloadAPI(
      APIService.downloadFile(data),
      (response) => downloadResponseHandler(response, fileName),
      (err) => {
        console.log("Error", err);
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      },
      true
    );
  };
  const rowStyle = { background: 'white' };

  return (
   
    <div className="App">
      <div className="row text-end">
        <div className="col-md-12">
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={props.sendBack}
          ></span>
        </div>
      </div>
      {initialValues &&
        <Formik initialValues={initialValues} validationSchema={validationSchema} enableReinitialize>
          {(prop) => {
            const {
              values,
              touched,
              errors,
              handleBlur,
              handleSubmit,
              isSubmitting,
            } = prop;
            return (
              loader ?(
                <div className="row" id="preloader">
                <div className="col-12 col-lg-12 loader-margin text-center loadingCss">
                  <div className="a-loading a-primary a-m-10 loadingText" role="status">
                   Loading...
                   <Loading loadingType='circular' indeterminate={true} compact={false}></Loading>
                  </div>
                </div>
              </div>
              )
          :
              <form onSubmit={handleSubmit}>
                <div className="row ">
                  <div className="col-md-12">
                    <div className="row ">
                      <div className="col-sm-6">
                        <div className="cv-input-field-container pt-0 pb-0">
                          <label htmlFor="IDComments" className="cv-input-label">Assessment ID</label>
                          <input
                            className="cv-input-field"
                            onBlur={handleBlur}
                            id="IDComments"
                            type="text"
                            value={values.assessmentID}
                            name="assessmentID"
                            placeholder="Enter Assessment ID"
                            disabled
                          />
                        </div>
                        {errors.assessmentID && touched.assessmentID && (
                          <div className="form-label error">
                            {errors.assessmentID}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <div className="cv-input-field-container pt-0 pb-0">
                          <label className="cv-input-label">
                            Third Party Name <span className="asterisk-required">*</span>
                          </label>
                          <Select
                            className="cv-input-field"
                            dropdownRenderMode="portal"
                            data={vendors}
                            valueKey="vendor_id"
                            labelKey="vendor_name"
                            value={values.vendorName}
                            dropdownAlwaysDown={false}
                            name="assessment"
                            placeholder="Select Third Party Name"
                            disabled
                          ></Select>
                        </div>
                        {errors.vendorName && touched.vendorName && (
                          <div className="form-label error">
                            {errors.vendorName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-sm-6">
                        <div className="cv-input-field-container pt-0 pb-0">
                          <label htmlFor="scopeComments" className="cv-input-label">
                            Scope of Assessment{" "}
                            <span className="asterisk-required">*</span>
                          </label>
                          <input
                            className="cv-input-field"
                            onBlur={handleBlur}
                            id="scopeComments"
                            type="text"
                            value={values.scopeOfAssessment}
                            name="scope Of Assessment"
                            placeholder="Please enter scope of assessment"
                            disabled
                          />
                        </div>
                        {errors.scopeOfAssessment &&
                          touched.scopeOfAssessment && (
                            <div className="form-label error">
                              {errors.scopeOfAssessment}
                            </div>
                          )}
                      </div>
                      <div className="col-sm-6">
                        <div className="cv-input-field-container pt-0 pb-0">
                          <label className="cv-input-label">
                            Third Party Manager <span className="asterisk-required">*</span>
                          </label>
                          <Select
                            className="cv-input-field"
                            dropdownRenderMode="portal"
                            type="email"
                            data={manager}
                            valueKey="user_id"
                            labelKey="user_name"
                            value={values.manager}
                            dropdownAlwaysDown={false}
                            name="assessment"
                            placeholder="Select Manager"
                            disabled
                          ></Select>
                        </div>
                        {errors.manager && touched.manager && (
                          <div className="form-label error">{errors.manager}</div>
                        )}
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-sm-6">
                        <div className="cv-input-field-container pt-0 pb-0">
                          <label htmlFor="respondentComments" className="cv-input-label">
                            Third Party respondent{" "}
                            <span className="asterisk-required">*</span>
                          </label>
                          <input
                            className="cv-input-field"
                            onBlur={handleBlur}
                            id="respondentComments"
                            type="text"
                            value={values.respondent}
                            name="respondent"
                            placeholder="Please enter third party respondent"
                            disabled
                          />
                        </div>
                        {errors.respondent && touched.respondent && (
                          <div className="form-label error">
                            {errors.respondent}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <div className="cv-input-field-container pt-0 pb-0">
                          <label className="cv-input-label">Work Program</label>
                          <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            className="cv-input-field"
                            data={workProgramName}
                            valueKey="workprogram_id"
                            labelKey="work_program_name"
                            value={values.workProgram}
                            dropdownAlwaysDown={false}
                            name="Third Party Name"
                            placeholder="Select work program Name"
                            disabled
                          ></Select>
                        </div>
                        {errors.workProgram && touched.workProgram && (
                          <div className="form-label error">
                            {errors.workProgram}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-sm-6">
                        <div className="cv-input-field-container pt-0 pb-0">
                          <label htmlFor="vendorComments" className="cv-input-label">
                            Vendor Comment{" "}
                            <span className="asterisk-required">*</span>
                          </label>
                          <input
                            className="cv-input-field"
                            onBlur={handleBlur}
                            id="vendorComments"
                            type="text"
                            value={values.vendorComment}
                            name="respondent"
                            placeholder="Please enter vendor comment"
                            disabled
                          />
                        </div>

                      </div>
                      
                    </div>
                    <div className="row ">
                    <div className="col-sm-12 mt-3">
                    Note: Double-click on a cell in the table under the columns Assessor Comments,Closure Status,Risk Rating to update it's content.

                      </div></div>
                  </div>
                </div>

                <div className="row pt-5 pl-3">
                  <div className="col-lg-12 mt-3 pl-1">
                    <>
                      <div className="exportButton">
                        <Button className='secondaryButton removeRadius'
                          kind='secondary' onClick={() => onBtnExport()}>Export</Button>
                      </div>

                      <div className="example-wrapper">

                        <div className="searchTable">
                          <span>Search:</span>
                          <input
                            type="text"
                            id="filter-text-box"
                            placeholder="search..."
                            onInput={onFilterTextBoxChanged}
                          />
                        </div>
                      </div>
                      <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                        <AgGridReact
                          rowData={tableData}
                          columnDefs={wpCategoryData && wpCategoryData[0].workprogramcategory == 1 ? colDefs1 : colDefs2}
                          defaultColDef={defaultColDef}
                          onCellValueChanged={onCellValueChanged}
                          pagination={true}
                          onGridReady={onGridReady}
                          rowStyle={rowStyle}
                        />
                      </div>
                    </>
                  </div>
                </div>
                <div className="row m-0">
                  <div className="col-sm-6 mt-3">
                    <div className="">
                      <label className="cv-input-label">
                        Assessor Comments <span className="asterisk-required"></span>
                      </label>
                      <TextArea
                        className="cv-input-field input-field-border"
                        type="text"
                        value={comments}
                        onChange={handleChangeComment}
                        name="comments"
                        placeholder="Add your comments."
                      />
                      {commentsFormat && (
                        <label className="requiredComments">
                          Only alphabets and some special characters are allowed
                          for this field
                        </label>
                      )}
                    </div>
                  </div>
                </div>
                <div className="options-container">
                {props.RequestDetails[0].vendor_review_status!='Reviewed/Approved' &&
                <>
                  <button
                    disabled={isSubmitting}
                    type="button"
                    className="save-button"
                    onClick={() => handleStatus("Approved")}
                  >
                    Approve
                  </button>
                  <button
                    disabled={isSubmitting}
                    type="button"
                    className="save-button m-l-2"
                    onClick={() => handleStatus("Rejected")}
                  >
                    Reject
                  </button>
                  <button
                    disabled={isSubmitting}
                    type="button"
                    className="save-button m-l-2"
                    onClick={() => handleStatus("Save")}
                  >
                    Save
                  </button>
                    </>
                }
                  <button
                    className="cancel-button m-l-2"
                    type="reset"
                    onClick={props.sendBack}
                  >
                    Cancel
                  </button>
                
                </div>
              </form>
            );
          }}
        </Formik>
      }

      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          <div className="modal-title">
            {`Are you sure you want to ${assessorStatus.toLowerCase().replace('approved', 'approve').replace('rejected', 'reject')} the assessment?`}
          </div>
          <ModalFooter>
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              No
            </button>

            <button
              type="submit"
              className="save-button m-l-2"
              onClick={handleUpdate}
            >
              Yes
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

AssessorComments.propTypes = {
  RequestDetails: PropTypes.any,
  tableDataProp: PropTypes.any,
  wpCategoryData: PropTypes.any,
  getSelfAssessmentsforAssessor: PropTypes.any,
  sendBack: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.any
}
